var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1609 3.01814L13.1309 3.08814L10.2309 9.81814H7.38094C6.70094 9.81814 6.05094 9.95814 5.46094 10.2081L7.21094 6.02814L7.25094 5.92814L7.32094 5.76814C7.34094 5.70814 7.36094 5.64814 7.39094 5.59814C8.70094 2.56814 10.1809 1.87814 13.1609 3.01814Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5505 10.0176C18.1005 9.87758 17.6205 9.81758 17.1405 9.81758H10.2305L13.1305 3.08758L13.1605 3.01758C13.3105 3.06758 13.4505 3.13758 13.6005 3.19758L15.8105 4.12758C17.0405 4.63758 17.9005 5.16758 18.4205 5.80758C18.5205 5.92758 18.6005 6.03758 18.6705 6.16758C18.7605 6.30758 18.8305 6.44758 18.8705 6.59758C18.9105 6.68758 18.9405 6.77758 18.9605 6.85758C19.2305 7.69758 19.0705 8.72758 18.5505 10.0176Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0217 14.6984V16.6484C22.0217 16.8484 22.0117 17.0484 22.0017 17.2484C21.8117 20.7384 19.8617 22.4984 16.1617 22.4984H8.36172C8.12172 22.4984 7.88172 22.4784 7.65172 22.4484C4.47172 22.2384 2.77172 20.5384 2.56172 17.3584C2.53172 17.1284 2.51172 16.8884 2.51172 16.6484V14.6984C2.51172 12.6884 3.73172 10.9584 5.47172 10.2084C6.07172 9.95836 6.71172 9.81836 7.39172 9.81836H17.1517C17.6417 9.81836 18.1217 9.88836 18.5617 10.0184C20.5517 10.6284 22.0217 12.4884 22.0217 14.6984Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21 6.02734L5.46 10.2073C3.72 10.9573 2.5 12.6873 2.5 14.6973V11.7673C2.5 8.92734 4.52 6.55734 7.21 6.02734Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0186 11.7677V14.6977C22.0186 12.4977 20.5586 10.6277 18.5586 10.0277C19.0786 8.72766 19.2286 7.70766 18.9786 6.85766C18.9586 6.76766 18.9286 6.67766 18.8886 6.59766C20.7486 7.55766 22.0186 9.52766 22.0186 11.7677Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.847a996a4622ee447cbe0b95d4bbd427.svg";
export { ForwardRef as ReactComponent };